import React from "react";
import PropTypes from "prop-types";
import H from "../Typography/H";
import HorizontalSlider from "../HorizontalSlider";
import ProductCard from "../ProductCard";

import styles from "./product-cards.module.scss";

function ProductCards(props) {
  const {products, title} = props;
  return products && products.length ? (
    <div className={styles.root}>
      <H level={2} className={styles.title}>
        {title}
      </H>
      <div className={styles.content}>
        <HorizontalSlider
          dots={false}
          slidesToScroll={1}
          variableWidth
          slidesToShow={6}
          infinite={false}
          responsive={[
            {
              breakpoint: 2275,
              settings: {
                slidesToShow: 5
              }
            },
            {
              breakpoint: 1715,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 1240,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 925,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 585,
              settings: {
                slidesToShow: 1
              }
            }
          ]}
        >
          {products.map((item) => (
            <ProductCard
              key={item.id}
              size="tile"
              content={item}
              className={styles.card}
            />
          ))}
        </HorizontalSlider>
      </div>
    </div>
  ) : null;
}

ProductCards.propTypes = {
  products: PropTypes.array,
  title: PropTypes.string
};

export default ProductCards;
